import * as d3 from 'd3';

export default function produceBiomeColorDict(colorsData) {
    const biomeCatogriesSet = new Set(colorsData);
    const colorDict = {};
    if (typeof (colorsData[0]) === "number") {
        console.log("found number");
        return {}
    }
    // if colorsData[0] == 
    // Returns string


    const allPosibleArray = []
    biomeCatogriesSet.forEach(element => {
        const biomeInChuncks = element.split(':')
        // "root:Environmental:Aquatic:Freshwater:Sediment"
        for (let i = 1; i < biomeInChuncks.length + 1; i++) {
            const combinedChunk = biomeInChuncks.slice(0, i);
            // console.log(combinedChunk);
            allPosibleArray.push(combinedChunk.join(':'));
        }
    });
    // console.log(allPosibleArray);
    const possibleBiomeCatogriesSet = new Set(allPosibleArray)
    // console.log(allPosibleArray);
    // console.log(possibleBiomeCatogriesSet);



    // const baseColors = {
    //     'Environmental': {
    //         'Aquatic': {
    //             base: [0, 100, 255],                // Blue
    //             'Marine': [0, 119, 190],            // Darker blue
    //             'Freshwater': [65, 105, 225],       // Royal blue
    //             'Thermal_springs': [30, 144, 255],  // Dodger blue
    //         },
    //         'Terrestrial': {
    //             base: [34, 139, 34],                // Forest Green
    //             'Soil': [85, 107, 47],              // Dark Olive Green
    //         },
    //         base: [144, 238, 144]                   // Light Green
    //     },
    //     'Host-associated': {
    //         'Human': {
    //             base: [204, 156, 128],                  // light brown
    //             'Digestive_system': [255, 105, 180],    // Hot Pink
    //             'Respiratory_system': [219, 112, 147],  // Pale Violet Red
    //             'Skin': [190, 146, 118],                // brown
    //         },
    //         'Mammals': {
    //             base: [255, 127, 80],                   // Coral
    //             'Digestive_system': [233, 150, 122],    // Dark Salmon
    //             'Skin': [255, 99, 71],                  // Tomato
    //         },
    //         'Birds': [218, 165, 32],      // Goldenrod
    //         'Fish': [70, 130, 180],       // Steel Blue
    //         'Insecta': [255, 215, 0],     // Gold
    //         'Reptile': [154, 205, 50],    // Yellow Green
    //         'Mollusca': [233, 150, 122],  // Dark Salmon
    //         'Algae': [46, 139, 87],       // Sea Green
    //         'Animal': [240, 128, 128],    // Light Coral
    //         'Plants': [50, 205, 50],      // Lime Green
    //         base: [255, 228, 196]         // Bisque
    //     },
    //     'Engineered': {
    //         'Food_production': [210, 105, 30],  // Chocolate
    //         'Lab_enrichment': [147, 112, 219],  // Medium Purple
    //         'Solid_waste': [139, 69, 19],       // Saddle Brown
    //         base: [200, 143, 180]               // Rosy Brown
    //     },
    //     'Mixed': [128, 128, 128]                // Gray
    // };


    // for video:
    const baseColors = {
        'Environmental': {
            'Aquatic': {
                base: [0, 100, 255],                // Blue
                'Marine': {
                    base: [0, 119, 190],            // Darker blue
                    'Coastal': [0, 150, 200],       // Light sea blue
                    'Oceanic': [0, 80, 170],        // Deep blue
                    'Wetlands': [70, 130, 180],     // Steel blue
                    'Intertidal_zone': [30, 180, 210], // Turquoise
                    'Hydrothermal_vents': [0, 50, 150], // Dark marine blue
                    'Cold_seeps': [65, 105, 225],   // Royal blue
                    'Oil_seeps': [70, 90, 160],     // Muted blue
                },
                'Freshwater': {
                    base: [65, 105, 225],           // Royal blue
                    'Wetlands': [100, 149, 237],    // Cornflower blue
                    'Lake': [135, 206, 235],        // Sky blue
                    'Groundwater': [176, 224, 230], // Powder blue
                    'Lotic': [173, 216, 230],       // Light blue
                },
                'Thermal_springs': [30, 144, 255],  // Dodger blue
                'Non-marine_Saline_and_Alkaline': [150, 180, 210], // Pale blue
                'Estuary': [100, 140, 200],         // Medium blue
                'Sediment': [95, 158, 160],         // Cadet blue
                'Aquaculture': [0, 206, 209],       // Turquoise
            },
            'Terrestrial': {
                base: [34, 139, 34],                // Forest Green
                'Soil': {
                    base: [85, 107, 47],            // Dark Olive Green
                    'Loam': [107, 142, 35],         // Olive Drab
                    'Forest_soil': [60, 179, 113],  // Medium Sea Green
                    'Agricultural': [124, 252, 0],   // Lawn Green
                    'Desert': [189, 183, 107],      // Dark Khaki
                    'Permafrost': [176, 196, 222],  // Light Steel Blue
                    'Clay': [160, 82, 45],          // Sienna
                    'Mine': [139, 69, 19],          // Saddle Brown
                },
                'Deep_subsurface': [46, 139, 87],   // Sea Green
            },
            base: [144, 238, 144]                   // Light Green
        },
        'Host-associated': {
            'Human': {
                base: [204, 156, 128],              // Light brown
                'Digestive_system': {
                    base: [255, 105, 180],          // Hot Pink
                    'Oral': [255, 136, 229],         //  Pink
                    'Large_intestine': [219, 112, 147], // Pale Violet Red
                    'Intestine': [255, 182, 193],    // Light Pink
                },
                'Respiratory_system': {
                    base: [219, 112, 147],          // Pale Violet Red
                    'Nasopharyngeal': [255, 160, 122], // Light Salmon
                },
                'Reproductive_system': [255, 192, 203], // Pink
                'Skin': [190, 146, 118],            // Brown
            },
            'Mammals': {
                base: [255, 127, 80],               // Coral
                'Digestive_system': [233, 150, 122], // Dark Salmon
                'Gastrointestinal_tract': [255, 99, 71], // Tomato
                'Skin': [255, 160, 122],            // Light Salmon
            },
            'Birds': {
                base: [218, 165, 32],               // Goldenrod
                'Digestive_system': [184, 134, 11], // Dark Goldenrod
            },
            'Fish': {
                base: [70, 130, 180],               // Steel Blue
                'Digestive_system': [100, 149, 237], // Cornflower Blue
                'Skin': [176, 196, 222],            // Light Steel Blue
            },
            'Insecta': [255, 215, 0],              // Gold
            'Arthropoda': [218, 165, 32],          // Goldenrod
            'Reptile': [154, 205, 50],             // Yellow Green
            'Mollusca': {
                base: [233, 150, 122],              // Dark Salmon
                'Digestive_system': [240, 128, 128], // Light Coral
            },
            'Algae': {
                base: [46, 139, 87],                // Sea Green
                'Brown_Algae': [85, 107, 47],       // Dark Olive Green
            },
            'Animal': {
                base: [240, 128, 128],              // Light Coral
                'Digestive_system': [205, 92, 92],  // Indian Red
            },
            'Plants': {
                base: [50, 205, 50],                // Lime Green
                'Root': [34, 139, 34],              // Forest Green
                'Rhizosphere': [60, 179, 113],      // Medium Sea Green
            },
            'Cnidaria': [255, 140, 0],             // Dark Orange
            'Porifera': [255, 160, 122],           // Light Salmon
            base: [255, 228, 196]                   // Bisque
        },
        'Engineered': {
            'Food_production': {
                base: [210, 105, 30],               // Chocolate
                'Fermented_vegetables': [205, 133, 63], // Peru
                'Fermented_beverages': [242, 142, 28], // Beer
                'Dairy_products': [222, 184, 135],  // Burlywood
            },
            'Lab_enrichment': {
                base: [147, 112, 219],              // Medium Purple
                'Defined_media': [138, 43, 226],    // Blue Violet
            },
            'Lab_Synthesis': [148, 0, 211],         // Dark Violet
            'Solid_waste': {
                base: [139, 69, 19],                // Saddle Brown
                'Composting': [160, 82, 45],        // Sienna
            },
            'Biogas_plant': {
                base: [128, 0, 0],                  // Maroon
                'Wet_fermentation': [139, 0, 0],    // Dark Red
            },
            'Wastewater': {
                base: [165, 42, 42],                // Brown
                'Industrial_wastewater': [128, 0, 0], // Maroon
                'Activated_Sludge': [139, 69, 19],  // Saddle Brown
                'Water_and_sludge': [160, 82, 45],  // Sienna
            },
            'Bioreactor': {
                base: [148, 0, 211],                // Dark Violet
                'Continuous_culture': [138, 43, 226], // Blue Violet
            },
            'Built_environment': [169, 169, 169],   // Dark Gray
            'Bioremediation': [107, 142, 35],       // Olive Drab
            'Modeled': [192, 192, 192],            // Silver
            base: [200, 143, 180]                   // Rosy Brown
        },
        'Mixed': [128, 128, 128]                    // Gray
    };

    function getBaseColorForPath(parts) {
        let current = baseColors;
        let color = null;

        for (let i = 1; i < parts.length; i++) {
            const part = parts[i];
            if (current[part]) {
                if (Array.isArray(current[part])) {
                    color = current[part];
                } else if (current[part].base) {
                    color = current[part].base;
                }
                current = current[part];
            }
        }

        return color || (Array.isArray(current) ? current : current.base || [128, 128, 128]);
    }


    function generateUniqueColor(category) {
        const parts = category.split(':');
        const baseColor = getBaseColorForPath(parts);

        if (parts.length <= 3) {
            return baseColor;
        }

        // gradient for deep categories
        const depth = parts.length - 3;
        const maxDepth = 5;


        const lastPart = parts[parts.length - 1];
        const hash = lastPart.split('').reduce((acc, char) => {
            return char.charCodeAt(0) + ((acc << 5) - acc);
        }, 0);

        const gradientPosition = (Math.abs(hash) % 100) / 100;

        // lightness increase
        const colorVariation = 150;
        // darkness increase
        const darkenFactor = 0.5;

        const variations = [
            // lignter
            `rgb(${Math.min(255, baseColor[0] + colorVariation)}, 
                 ${Math.min(255, baseColor[1] + colorVariation)}, 
                 ${Math.min(255, baseColor[2] + colorVariation)})`,


            `rgb(${baseColor[0]}, ${baseColor[1]}, ${baseColor[2]})`,

            // darker
            `rgb(${Math.max(0, Math.floor(baseColor[0] * darkenFactor))}, 
                 ${Math.max(0, Math.floor(baseColor[1] * darkenFactor))}, 
                 ${Math.max(0, Math.floor(baseColor[2] * darkenFactor))})`
        ];

        let gradientColor;
        if (gradientPosition < 0.5) {
            gradientColor = d3.interpolateRgb(variations[2], variations[1])(gradientPosition * 2);
        } else {
            gradientColor = d3.interpolateRgb(variations[1], variations[0])((gradientPosition - 0.5) * 2);
        }

        const match = gradientColor.match(/\d+/g);
        return match.map(x => parseInt(x));
    }
    // possibleBiomeCatogriesSet.array.forEach(element => {
    //     generateUniqueColor

    // });

    possibleBiomeCatogriesSet.forEach(category => {
        const parts = category.split(':');

        if (parts.length === 1) {
            colorDict[category] = [128, 128, 128];
        } else {
            colorDict[category] = generateUniqueColor(category);
        }
    });
    // console.log(colorDict);

    return colorDict
}